import { Actions, ActionTypes } from '../actions/vpn-routing-configuration.action';
import { VpnRoutingConfigurationReducer } from '../models/vpn-routing.model';

const INITIAL_STATE: VpnRoutingConfigurationReducer = {
  id: 0,
  deviceId: 0,
  isVpnClientEnabled: true,
  vpn_and_routing: [],
  shuffledColumns: [
    { key: 'Name', field: 'name', hide: false, sort: '' },
    { key: 'Description', field: 'description', hide: false, sort: '' },
    { key: 'Server Name', field: 'server_name', hide: false, sort: '' },
    { key: 'Client Name', field: 'client_name', hide: false, sort: '' },
    {
      key: 'Public Server Name',
      field: 'public_server_name',
      hide: false,
      sort: '',
    },
    {
      key: 'Public Server Port',
      field: 'public_server_port',
      hide: false,
      sort: '',
    },
    {
      key: 'Local UDP Port',
      field: 'local_udp_port',
      hide: false,
      sort: '',
    },
    {
      key: 'Packet Forwarding Mode',
      field: 'packet_forwarding_mode',
      hide: false,
      sort: '',
    },
    { key: 'Tunnel area', field: 'tunnel_area', hide: false, sort: '' },
    {
      key: 'Cost',
      field: 'cost',
      hide: false,
      sort: '',
    },
    { key: 'LAN Subnets', field: 'lan_subnets', hide: false, sort: '' },
    {
      key: 'LAN Interfaces',
      field: 'lan_interfaces',
      hide: false,
      sort: '',
    },
    {
      key: 'Client Bridge',
      field: 'client_bridge',
      hide: false,
      sort: '',
    },
    {
      key: 'Bridge IP Address',
      field: 'bridge_ip_address',
      hide: false,
      sort: '',
    },
    {
      key: 'Bridge Members',
      field: 'bridge_members',
      hide: false,
      sort: '',
    },
    {
      key: 'Order',
      field: 'order_id',
      hide: false,
      sort: '',
    },
  ],
};

export function vpnRoutingConfigurationReducer(state = INITIAL_STATE, action: Actions) {
  switch (action.type) {
    case ActionTypes.SET_VPN_ROUTING_CONFIGURATION:
      action.payload.vpn_and_routing.forEach((vpnRouting) => {
        vpnRouting.lan_interfaces = vpnRouting.lan_interfaces.toString();
      });

      return {
        ...state,
        id: action.payload.id,
        deviceId: action.payload.device_id,
        isVpnClientEnabled: action.payload.enable_vpn_and_routing,
        vpn_and_routing: action.payload.vpn_and_routing,
      };
    case ActionTypes.VPN_ROUTING_COLUMN_SELECT:
      const selectedColumn = state.shuffledColumns.find(
        (column) => column.field === action.payload
      );
      if (selectedColumn) {
        selectedColumn.hide = false;
      }
      return {
        ...state,
      };
    case ActionTypes.VPN_ROUTING_COLUMNS_SELECT_ALL:
      state.shuffledColumns.forEach((column) => (column.hide = false));
      return {
        ...state,
      };
    case ActionTypes.VPN_ROUTING_COLUMN_DESELECT:
      const unSelectedColumn = state.shuffledColumns.find(
        (column) => column.field === action.payload
      );
      if (unSelectedColumn) {
        unSelectedColumn.hide = true;
      }
      return {
        ...state,
      };
    case ActionTypes.VPN_ROUTING_SHUFFLED_COLUMNS:
      return {
        ...state,
        shuffledColumns: [...action.payload],
      };
    case ActionTypes.ADD_VPN_ROUTING:
      const newConfiguration = {
        ...action.payload,
        order_id: state.vpn_and_routing.length + 1,
      };
      return {
        ...state,
        vpn_and_routing: [...state.vpn_and_routing, newConfiguration],
      };
    case ActionTypes.EDIT_VPN_ROUTING: {
      const updatedVpnConfig = state.vpn_and_routing.map((config) =>
        config.id === action.payload.id
          ? {
              ...action.payload,
              order_id: config.order_id,
            }
          : config
      );

      return {
        ...state,
        vpn_and_routing: updatedVpnConfig,
      };
    }

    case ActionTypes.DELETE_VPN_ROUTING: {
      const idsToDelete = action.payload;

      const filteredList = state.vpn_and_routing
        .filter((item) => !idsToDelete.includes(item.id))
        .map((item, index) => ({
          ...item,
          order_id: index + 1,
        }));

      return {
        ...state,
        vpn_and_routing: filteredList,
      };
    }

    case ActionTypes.CLEAR_VPN_ROUTING_CONFIGURATION:
      return INITIAL_STATE;

    case ActionTypes.SET_VPN_CLIENT_CONFIG_LEVEL_ENABLED_STATE:
      const val = state.vpn_and_routing.map((vpnClient) =>
        vpnClient.id === action.payload.vpnClientData.id
          ? { ...vpnClient, is_configuration_enabled: action.payload.isEnabled }
          : vpnClient
      );
      return {
        ...state,
        vpn_and_routing: val,
      };

    case ActionTypes.SET_VPN_CLIENT_DEVICE_LEVEL_ENABLED_STATE:
      return {
        ...state,
        isVpnClientEnabled: action.payload,
      };

    default:
      return state;
  }
}
